// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ywbU","badges":"styles_badges__3VhF5"};